import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  SelectProps,
  Typography,
} from '@mui/material';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

type SelectKitProps = {
  name: string;
  options:
    | string[]
    | { label: string; value: string | number | boolean; icon?: any }[];
} & SelectProps;

export const SelectKit = (props: SelectKitProps) => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();

  const formValue = watch(props.name);

  const selectValue = useMemo(() => {
    const options = props.options as any[];
    if (!!props.multiple) {
      if (formValue === undefined || formValue === null) {
        return [];
      }
      if (typeof props.options[0] === 'string') {
        return formValue;
      } else {
        return options.find(option => option.value === formValue).label;
      }
    } else {
      return formValue;
    }
  }, [formValue]);

  const onSelectChange = (e: any) => {
    let { value: option } = e.target;
    option = option?.value !== undefined ? option.value : option;

    setValue(props.name, option);
  };

  const renderValue = useMemo(() => {
    if (
      (typeof selectValue !== 'boolean' && !selectValue) ||
      (Array.isArray(selectValue) && !selectValue.length)
    ) {
      return () => (
        <Typography
          sx={{
            marginTop: '3px',
            color: '#A2A2A2',
          }}
        >
          {props.placeholder || 'Select'}
        </Typography>
      );
    }
  }, [selectValue]);

  const errorMessage: any = !!errors[props.name]?.message
    ? errors[props.name]?.message
    : '';

  const isError = !!errorMessage;

  return (
    <FormControl fullWidth error={isError}>
      <Select
        sx={{ minWidth: '275px' }}
        inputProps={{
          sx: { padding: '8.5px 14px' },
        }}
        displayEmpty
        value={selectValue}
        renderValue={renderValue}
        onChange={onSelectChange}
        {...props}
      >
        {props.options.map((option: any) => {
          const value = option?.value !== undefined ? option.value : option;
          const label = option?.label || option;

          return (
            <MenuItem
              sx={{
                padding: '14px 12px',
              }}
              key={label}
              value={value}
            >
              {option?.icon && (
                <span
                  style={{
                    marginRight: '7px',
                  }}
                >
                  {option.icon}
                </span>
              )}
              {label}
            </MenuItem>
          );
        })}
      </Select>
      {isError && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  );
};
